import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { logoutUser } from './authRoutes'
import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router'
//import { useState } from 'react'
import { Link } from 'react-router-dom'

function Header(props) {
    const loginVisible = props.mods.loginVisible
    const currentUser = props.mods.currentUser
    const setCurrentUser = props.mods.setCurrentUser
    const setIsAuthenticated = props.mods.setIsAuthenticated
    const isAuthenticated = props.mods.isAuthenticated
    const setUsername = props.mods.setUsername
    // const [logoutText, setLogoutText] = useState(false)
    const navigate = useNavigate()

    const handleClick = async () => {
        if (isAuthenticated === true) {
        setCurrentUser({})
        setIsAuthenticated(false)
        setUsername("")
        logoutUser()
        //showLogout()
        navigate('/auth/login')
        } else {
            navigate('/auth/login')
        }

    }

    return (
        <div className="mb-4 header">
            <Navbar className="navbar justify-content-between">
                {isAuthenticated ? <><Navbar.Brand className="headerUsername">{currentUser.user.username}</Navbar.Brand><span className='justify-content-end'><Button xs={2} onClick={handleClick} variant="outline-info" className=''>Logout</Button></span>
                </> : <Navbar.Brand></Navbar.Brand>}
            </Navbar>
            <Container>
            <Row>
                <Col xs={12} md={8} >
                    <h1 className="title">Date Shuffle</h1>
                </Col>
                <Col xs={12} md={{span: 2, offset: 2 }} className="loginCol">
                    {(isAuthenticated === true) ? null : loginVisible ?  <Button onClick={handleClick} className='loginButton defaultButton'>Login</Button> : null}
                </Col>
            </Row>
            </Container>
            <Container>
            {isAuthenticated ? 
            <Row>
                <Col xs={3} className="d-flex justify-content-center">
                    <Link to={'/'}><Button className="btn-dark defaultButton altDateButton">Dates</Button></Link>
                </Col>
                <Col xs={3} className="d-flex justify-content-center">
                    <Link to={'/shuffle'}><Button className="btn-dark defaultButton shuffleButton">Shuffle</Button></Link>
                </Col>
                <Col xs={3} className="d-flex justify-content-center">
                    <Link to={'/decks'}><Button className="btn-dark defaultButton deckButton">Decks</Button></Link>
                </Col>
                <Col xs={3} className="d-flex justify-content-center">
                    <Link to={'/ideas'}><Button className="btn-dark defaultButton editButton">Ideas</Button></Link>
                </Col>
            </Row> : null }
            </Container>
        </div>
    )
}

export default Header